import type { QuizBuilderSchema } from '@repo/schemas/quiz/quizBuilder';

import { useMutation } from '@tanstack/react-query';

import { QuizService } from './quizService';

export function useEditQuiz(id: string) {
  return useMutation({
    mutationFn: (data: Partial<QuizBuilderSchema>) => QuizService.editQuiz(id, data).then((response) => response.data),
  });
}
